import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { TypedTable } from "../../../components/TypedTable";
import { useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { Loading, QueryError } from "../../../components/Loading/Loading";
import type { InfoOF } from "@/ts/api/API";

interface TablaOrdenesProps {
	readonly familia: string[];
	readonly subfamilia: string[];
}
export function TablaOrdenes(props: TablaOrdenesProps) {
	const { data, error, isPending } = UseOrdenes({
		idsFamilia: props.familia,
		idsSubFamilia: props.subfamilia,
	});

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<InfoOF>();
		return [
			columnHelper.accessor("idOF", { header: "Número de OF", meta: { className: "dt-center" } }),
			columnHelper.display({ header: "Conjunto", cell: info => `${info.row.original.idConjunto}-${info.row.original.descripcion}`, meta: { className: "dt-center" } }),
			columnHelper.accessor("situacion", { header: "Situación", meta: { className: "dt-center" } }),
			columnHelper.accessor("cantLanzada", { header: "Cantidad Lanzada", cell: info => info.getValue().toLocaleString("es-ES"), meta: { className: "dt-center" } }),
			columnHelper.accessor("cantAcabada", { header: "Cantidad Terminada", cell: info => info.getValue().toLocaleString("es-ES"), meta: { className: "dt-center" } }),
		];
	}, []);

	if (error) return <QueryError error={error} fallback="Error al cargar las órdenes de fabricación" />;
	if (isPending) return <Loading />;

	return (
		<TypedTable
			// scrollY: "600px",
			className="dataTable display"
			data={data}
			columns={columns}
			pagination
		/>
	);
}





function UseOrdenes(parametros: UseOrdenesParams) {
	return useQuery<InfoOF[]>({
		queryKey: ["getOFsEnCurso", parametros],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<InfoOF[]>("GET", "/api/v1/getOFsEnCurso", parametros);
		}
	});
}
interface UseOrdenesParams {
	idsFamilia: string[];
	idsSubFamilia: string[];
};